import React from 'react';
import { Link } from 'gatsby';
import './styles.sass';
import { frontAppUrl } from 'utils/siteConfig';

const startAcademyOnboardingFor = (slug) => {
  window.location.href = `${frontAppUrl}/academy.html?slug=${slug}&refresh=true`;
};

export default (props) => {
  const {
    path, text, className, goToProgramSlug
  } = props;

  if (goToProgramSlug)
    return <a onClick={() => startAcademyOnboardingFor(goToProgramSlug)} className={`${className} lg`}>{text}</a>

  if (!path) return null;

  const htmlAttrs = {};
  
  if (path.includes("/consulter")) {
    htmlAttrs["rel"] = "nofollow";
  }

  return <Link to={path} className={className} {...htmlAttrs} >{text}</Link>
};
